export const MERCADO_PAGO_METHOD_ID = 1;

interface WholesaleSurchargeInput {
  /** Sum of the wholesale-priced items in the cart. */
  wholesaleSubtotal?: number | null;
  /** Surcharge rate, as a percentage (8 means 8%). */
  percent?: number | null;
  /** Payment method currently selected, or null when none is yet. */
  selectedMethod: number | null;
  /** Whether the QR variant of Mercado Pago is the one selected. */
  useQr?: boolean;
}

/**
 * Surcharge to add for the selected payment method, rounded to cents.
 *
 * Cards go through Mercado Pago and share its method id, so they pay it too.
 * QR shares the id as well but is exempt — Mercado Pago barely charges us for
 * it. Every other method pays nothing.
 */
export function resolveWholesaleSurcharge({
  wholesaleSubtotal,
  percent,
  selectedMethod,
  useQr = false,
}: WholesaleSurchargeInput): number {
  const base = wholesaleSubtotal ?? 0;
  const rate = percent ?? 0;

  if (base <= 0 || rate <= 0) return 0;
  if (selectedMethod !== MERCADO_PAGO_METHOD_ID || useQr) return 0;

  return Math.round(base * rate) / 100;
}
